/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingimageunprocessable2Inputs */

const en_crosspostingimageunprocessable2 = /** @type {(inputs: Crosspostingimageunprocessable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This image could not be processed. Remove it and add it again.`)
};

const de_crosspostingimageunprocessable2 = /** @type {(inputs: Crosspostingimageunprocessable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Bild konnte nicht verarbeitet werden. Entferne es und füge es erneut hinzu.`)
};

/**
* | output |
* | --- |
* | "This image could not be processed. Remove it and add it again." |
*
* @param {Crosspostingimageunprocessable2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingimageunprocessable2 = /** @type {((inputs?: Crosspostingimageunprocessable2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingimageunprocessable2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingimageunprocessable2(inputs)
	return de_crosspostingimageunprocessable2(inputs)
});
export { crosspostingimageunprocessable2 as "crosspostingImageUnprocessable" }